import React, {Component} from 'react';
import {getInterestByID} from "../../../../services/interestsService"
import {Redirect, withRouter} from 'react-router-dom';
import LoadingComponent from "../../common/loadingComponent";
import InterestForm from "./InterestForm";

class LoadInterestForm extends Component {

    _isMounted = false;

    state = {
        RedirectToLoginPage:false,
        isLoading : false,
        userToken : this.props.user,
        interest : {},
        locale : this.props.locale
    };


    componentDidMount() {
        this._isMounted = true;

        if (this.props.id !== undefined){
            this.onLoadInterest();
        }
    }

    componentWillUnmount() {
        this._isMounted = false;
    }

    onLoadInterest = async () =>{
        try {
            this.setState({isLoading:true});
            const {data: interest} = await getInterestByID(this.props.id);
            if (this._isMounted){
                this.setState({
                    interest,
                    isLoading: false
                });
            }

        }  catch(err)  {
            if (this._isMounted){
                this.setState({isLoading: false, RedirectToLoginPage:true});
            }
        }
    }


    renderPage = () => {
        return (
          <>
              <InterestForm
                  isAdminForm = {(this.props.id)?true:false}
                  locale = {this.props.locale}
                  interest = {this.state.interest}
              />
          </>
        );
    }

    render() {

        if (this.state.RedirectToLoginPage) {
            const loginPage = `/${this.state.locale}/login`
            return <Redirect to={loginPage}  />
        }

        return (
            <>
                {this.state.isLoading ? <LoadingComponent/> : this.renderPage()}
            </>
        );
    }
}

export default withRouter(LoadInterestForm);
